// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1pwZL","form":"styles_form__2xnD-","buttons":"styles_buttons__2TAUk"};